import type { Grid } from '@syncfusion/ej2-grids';
import type { ResourcesModel } from '@syncfusion/ej2-schedule';
import type { Booking } from './scheduleCommon';
import { closeSchedulePopupDialog, getPrice, updateLinkedAutoCompleteFieldValue } from './scheduleCommon';
import { isReservationNewPerson, ReservationExistingPerson, ReservationNewPerson, ReservationPerson, type ReservationState } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/model';

export async function scheduleEditDialog(
    peopleList: any[],
    packageList: any[],
    resources: ResourcesModel[],
    booking: Booking | null,
    reservationState: ReservationState) {

    await import('@syncfusion/ej2-base/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-buttons/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-calendars/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-dropdowns/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-inputs/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-navigations/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-popups/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-splitbuttons/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-notifications/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-grids/styles/bootstrap5.3.css');

    await import('../loadSyncfusion');

    const { Grid } = await import('@syncfusion/ej2-grids');

    const { format } = await import('date-fns')

    const { dateSelection } = await import('./dateSelection');
    const { inputAutoComplete } = await import('./inputAutoComplete');
    const { initialCreateInputs } = await import('./initialCreateInputs'); 
    const { scheduleSelectDropdown } = await import('./scheduleSelectDropdown');
    const { scheduleNumberInput } = await import('./scheduleNumberInput');

    let firstnameEle: any;
    let lastnameEle: any;
    let phoneEle: any;
    let emailEle: any;

    const data = {
        async resetValue() { 
            closeSchedulePopupDialog(); 

            this.rooms = [ { RoomType: '', Room: '', Rate: '', Adults: '1', Services: [''] }]; this.personInfo = {
                firstName: '',
                lastName: '',
                phone: '',
                email: ''
            };
            this.startDate = '';
            this.endDate = '';
            this.additionalServices = [];

            //await dateSelection(`dropdown-start`, null);
            //await dateSelection(`dropdown-end`, null);

            await inputAutoComplete("input-firstname", null);
            await inputAutoComplete("input-lastname", null);
            await inputAutoComplete("input-phone", null);
            await inputAutoComplete("input-email", null);
        },
        personInfo: {
            firstName: '',
            lastName: '',
            phone: '',
            email: '',
            personId: ''
        },
        startDate: '',
        endDate: '',
        rooms: [
            { RoomType: '', Room: '', Rate: '', Adults: '1', Services: [undefined] as any[] }
        ],
        additionalServices: [] as any[],
        clearPerson() {
            this.personInfo.firstName = '';
            this.personInfo.lastName = '';
            this.personInfo.phone = '';
            this.personInfo.email = '';
            this.personInfo.personId = '';

            (document.getElementById("input_input-firstname") as HTMLInputElement).disabled = false;
            (document.getElementById("input_input-lastname") as HTMLInputElement).disabled = false;
            (document.getElementById("input_input-phone") as HTMLInputElement).disabled = false;
            (document.getElementById("input_input-email") as HTMLInputElement).disabled = false;

            firstnameEle.value = '';
            lastnameEle.value = '';
            phoneEle.value = '';
            emailEle.value = '';

            reservationState.Person.setValue(null);
        },
        async init() {
            // Initialize any EJ2 components here if needed
            // scheduleDialog(this, [], 'auto');

            const self = this;
            //const firstnameEle = await inputAutoComplete("input-firstname", self.personInfo.firstName, "First name", peopleList, "FirstName", function (e) {
            //    self.personInfo.firstName = e.value;
            //});
            //const lastnameEle = await inputAutoComplete("input-lastname", self.personInfo.lastName, "Last name", peopleList, "LastName", function (e) {
            //    self.personInfo.lastName = e.value;
            //});
            //const phoneEle = await inputAutoComplete("input-phone", self.personInfo.phone, "Phone no.", peopleList, "PhoneNumber", function (e) {
            //    self.personInfo.phone = e.value;
            //});
            //const emailEle = await inputAutoComplete("input-email", self.personInfo.email, "Email", peopleList, "Email", function (e) {
            //    self.personInfo.email = e.value;
            //});
        
            //const containerEle = document.getElementById('container_person-search-grid');
        
            //const personSearchGrid = new Grid({
            //    dataSource: [],
            //    columns: [
            //        { field: 'FirstName', headerText: 'First Name', width: 120 },
            //        { field: 'LastName', headerText: 'Last Name', width: 120 },
            //        { field: 'PhoneNumber', headerText: 'Phone', width: 120 },
            //        { field: 'Email', headerText: 'Email', width: 120 }
            //    ],
            //    height: 'auto',
            //    rowSelected: (args: any) => {
            //        updateLinkedAutoCompleteFieldValue("input-firstname", args.data.FirstName);
            //        updateLinkedAutoCompleteFieldValue("input-lastname", args.data.LastName);
            //        updateLinkedAutoCompleteFieldValue("input-phone", args.data.PhoneNumber);
            //        updateLinkedAutoCompleteFieldValue("input-email", args.data.Email);
            //        self.personInfo.personId = args.data.PersonId
        
            //        containerEle.style.display = "none"
            //    },
            //    dataBound: () => {
            //        if (personSearchGrid.currentViewData.length === 0) {
            //            // hide when no record found.
            //            containerEle.style.display = "none"
            //            self.personInfo.personId = ''
            //        }
            //    }
            //});
        
            //personSearchGrid.appendTo("#person-search-grid");
        
            //containerEle.addEventListener('focusout', (event: FocusEvent) => {
            //    if (!(personSearchGrid.element.contains(event.target as Node) ||
            //        firstnameEle.element.contains(event.target as Node) ||
            //        lastnameEle.element.contains(event.target as Node) ||
            //        phoneEle.element.contains(event.target as Node) ||
            //        emailEle.element.contains(event.target as Node)) && containerEle.style.display !== "none") {
            //        containerEle.style.display = "none"
            //    }
            //});
            //document.addEventListener('click', (event: MouseEvent) => {
            //    if (!(personSearchGrid.element.contains(event.target as Node) ||
            //        firstnameEle.element.contains(event.target as Node) ||
            //        lastnameEle.element.contains(event.target as Node) ||
            //        phoneEle.element.contains(event.target as Node) ||
            //        emailEle.element.contains(event.target as Node)) && containerEle.style.display !== "none") {
            //        containerEle.style.display = "none"
            //    }
            //});

            if (booking) {
                if (booking.person) {
                    this.personInfo.firstName = booking.person.firstName
                    this.personInfo.lastName = booking.person.lastName
                    this.personInfo.phone = booking.person.phone
                    this.personInfo.email = booking.person.email
                    this.personInfo.personId = booking.person.personId
                }

                this.startDate = new Date(booking.startDate)
                this.endDate = new Date(booking.endDate)

                this.rooms = booking.rooms
                this.additionalServices = booking.programOnly
                //scheduleDialog(this, peopleList, '1200px');
                //openScheduleDialog()

                const self = this;
                //dateSelection(`dropdown-start`, self.startDate, function (e) {
                //    self.startDate = e.value.toISOString();
                //});
                //dateSelection(`dropdown-end`, self.endDate, function (e) {
                //    self.endDate = e.value.toISOString();
                //});

                firstnameEle = await inputAutoComplete("input-firstname", self.personInfo.firstName, "First name", peopleList, "FirstName", function (e) {
                    if (self.personInfo.personId) {
                        return;
                    }

                    self.personInfo.firstName = e.value;

                    let nextPerson: ReservationNewPerson;
                    const currentPerson = reservationState.Person.value;

                    if (isReservationNewPerson(currentPerson)) {
                        nextPerson = {
                            ...currentPerson,
                            FirstName: e.value
                        };
                    } else {
                        nextPerson = {
                            [ReservationPerson]: true,
                            [ReservationNewPerson]: true,
                            FirstName: e.value,
                            LastName: null,
                            Email: null,
                            Phone: null
                        };
                    }

                    reservationState.Person.setValue(nextPerson);
                });

                lastnameEle = await inputAutoComplete("input-lastname", self.personInfo.lastName, "Last name", peopleList, "LastName", function (e) {
                    if (self.personInfo.personId) {
                        return;
                    }

                    self.personInfo.lastName = e.value;

                    let nextPerson: ReservationNewPerson;
                    const currentPerson = reservationState.Person.value;

                    if (isReservationNewPerson(currentPerson)) {
                        nextPerson = {
                            ...currentPerson,
                            LastName: e.value
                        };
                    } else {
                        nextPerson = {
                            [ReservationPerson]: true,
                            [ReservationNewPerson]: true,
                            FirstName: null,
                            LastName: e.value,
                            Email: null,
                            Phone: null
                        };
                    }

                    reservationState.Person.setValue(nextPerson);
                });

                phoneEle = await inputAutoComplete("input-phone", self.personInfo.phone, "Phone no.", peopleList, "PhoneNumber", function (e) {
                    if (self.personInfo.personId) {
                        return;
                    }

                    self.personInfo.phone = e.value;

                    let nextPerson: ReservationNewPerson;
                    const currentPerson = reservationState.Person.value;

                    if (isReservationNewPerson(currentPerson)) {
                        nextPerson = {
                            ...currentPerson,
                            Phone: e.value
                        };
                    } else {
                        nextPerson = {
                            [ReservationPerson]: true,
                            [ReservationNewPerson]: true,
                            FirstName: null,
                            LastName: null,
                            Email: null,
                            Phone: e.value
                        };
                    }

                    reservationState.Person.setValue(nextPerson);
                });

                emailEle = await inputAutoComplete("input-email", self.personInfo.email, "Email", peopleList, "Email", function (e) {
                    if (self.personInfo.personId) {
                        return;
                    }

                    self.personInfo.email = e.value;

                    let nextPerson: ReservationNewPerson;
                    const currentPerson = reservationState.Person.value;

                    if (isReservationNewPerson(currentPerson)) {
                        nextPerson = {
                            ...currentPerson,
                            Email: e.value
                        };
                    } else {
                        nextPerson = {
                            [ReservationPerson]: true,
                            [ReservationNewPerson]: true,
                            FirstName: null,
                            LastName: null,
                            Email: e.value,
                            Phone: null
                        };
                    }

                    reservationState.Person.setValue(nextPerson);
                });

                const containerEle = document.getElementById('container_person-search-grid');

                const personSearchGrid = new Grid({
                    dataSource: [],
                    columns: [
                        { field: 'FirstName', headerText: 'First Name', width: 120 },
                        { field: 'LastName', headerText: 'Last Name', width: 120 },
                        { field: 'PhoneNumber', headerText: 'Phone', width: 120 },
                        { field: 'Email', headerText: 'Email', width: 120 }
                    ],
                    height: 'auto',
                    rowSelected: (args: any) => {
                        updateLinkedAutoCompleteFieldValue("input-firstname", args.data.FirstName);
                        updateLinkedAutoCompleteFieldValue("input-lastname", args.data.LastName);
                        updateLinkedAutoCompleteFieldValue("input-phone", args.data.PhoneNumber);
                        updateLinkedAutoCompleteFieldValue("input-email", args.data.Email);
                        self.personInfo.personId = args.data.PersonId

                        containerEle.style.display = "none"

                        const person: ReservationExistingPerson = {
                            [ReservationPerson]: true,
                            [ReservationExistingPerson]: true,
                            PersonId: args.data.PersonId,
                            ContactId: args.data.ContactId
                        };

                        reservationState.Person.setValue(person);

                        (document.getElementById("input_input-firstname") as HTMLInputElement).disabled = true;
                        (document.getElementById("input_input-lastname") as HTMLInputElement).disabled = true;
                        (document.getElementById("input_input-phone") as HTMLInputElement).disabled = true;
                        (document.getElementById("input_input-email") as HTMLInputElement).disabled = true;
                    },
                    dataBound: () => {
                        if (personSearchGrid.currentViewData.length === 0) {
                            // hide when no record found.
                            containerEle.style.display = "none"
                            self.personInfo.personId = ''
                        }
                    }
                });

                personSearchGrid.appendTo("#person-search-grid");

                containerEle.addEventListener('focusout', (event: FocusEvent) => {
                    if (!(personSearchGrid.element.contains(event.target as Node) ||
                        firstnameEle.element.contains(event.target as Node) ||
                        lastnameEle.element.contains(event.target as Node) ||
                        phoneEle.element.contains(event.target as Node) ||
                        emailEle.element.contains(event.target as Node)) && containerEle.style.display !== "none") {
                        containerEle.style.display = "none"
                    }
                });
                document.addEventListener('click', (event: MouseEvent) => {
                    if (!(personSearchGrid.element.contains(event.target as Node) ||
                        firstnameEle.element.contains(event.target as Node) ||
                        lastnameEle.element.contains(event.target as Node) ||
                        phoneEle.element.contains(event.target as Node) ||
                        emailEle.element.contains(event.target as Node)) && containerEle.style.display !== "none") {
                        containerEle.style.display = "none"
                    }
                });

                if (reservationState.ReservationId) {
                    (document.getElementById("input_input-firstname") as HTMLInputElement).disabled = true;
                    (document.getElementById("input_input-lastname") as HTMLInputElement).disabled = true;
                    (document.getElementById("input_input-phone") as HTMLInputElement).disabled = true;
                    (document.getElementById("input_input-email") as HTMLInputElement).disabled = true;
                }
           
            }
            else {
                // scheduleDialog(this, peopleList);

                //dateSelection(`dropdown-start`, self.startDate, function (e) {
                //    self.startDate = e.value.toISOString();
                //});
                //dateSelection(`dropdown-end`, self.endDate, function (e) {
                //    self.endDate = e.value.toISOString();
                //});

                //const index = 0;

                //scheduleSelectDropdown("dropdown-roomtype-" + index, [], true, null);// args.data.RoomType);
                //scheduleSelectDropdown("dropdown-room-" + index, [], true, null);// args.data.Room);
            }
            
        },
        addRoom() {
            this.rooms.push({ RoomType: '', Room: '', Rate: '', Adults: '1', Services: [undefined] });
        },
        removeRoom(index: any) {
            this.rooms.splice(index, 1);
        },
        updateServices(roomIndex: any) {
            const room = this.rooms[roomIndex];
            const numAdults = room.Adults;
            if (numAdults >
                room.Services.length) {
                // Add services if the number of adults increased
                for (let i = room.Services.length; i < numAdults; i++) {
                    room.Services.push(undefined);
                }
            } else if (numAdults < room.Services.length) {
                // Remove services if the number of adults decreased
                room.Services.splice(numAdults);
            }
        },
        addAdditionalService() {
            this.additionalServices.push({ name: undefined, amount: 0 });
            console.log(this.additionalServices.length)
        },
        removeAdditionalService(index: any) {
            this.additionalServices.splice(index, 1);
        },
        save() {
            // Handle saving the data here
            console.log('Saving booking data...', {
                personInfo: this.personInfo,
                startDate: this.startDate,
                endDate: this.endDate,
                rooms: this.rooms,
                additionalServices: this.additionalServices
            });
            this.closePopup();
        },
        async initRoom(index: any) {
            await initialCreateInputs(this, index,
                packageList,
                resources)
        },
        async initAdult(index: any, adultIndex: any) {
            console.log('init adult', index, adultIndex)
            var self = this;
            await scheduleSelectDropdown('dropdown-service-' + index + '-' + adultIndex, packageList, true, null, function (e) {
                const services = self.rooms[index].Services
                services[adultIndex] = e.itemData.Value;
                const rooms = self.rooms;
                rooms[index].Services = services

                self.rooms = rooms;

                // add on change program should trigger price query
                // const priceButton = document.getElementById("button_package-price-" + index + '-' + adultIndex) as HTMLButtonElement;
                // priceButton.click();
                getPrice('packages={\"'+e.itemData.Value+'\":1}', 'text_package-price-'+index+'-'+adultIndex);
            })

        },
        async initProgramOnly(programOnlyIndex: any) {
            var self = this;
            await scheduleSelectDropdown('dropdown-programonly-' + programOnlyIndex, packageList, true, self.additionalServices[programOnlyIndex].name, function (e) {
                self.additionalServices[programOnlyIndex].packageId = e.value;
            });

            await scheduleNumberInput('number-programonly-' + programOnlyIndex, self.additionalServices[programOnlyIndex].amount, function (e) {
                self.additionalServices[programOnlyIndex].amount = e.value;
            });
        },
        getVals(addProps: string) {
            const data = {
                personInfo: this.personInfo,
                rooms: this.rooms,
                startDate: this.startDate,
                endData: this.endDate,
                additionalServices: this.additionalServices
            };

            if (!addProps) {
                return JSON.stringify(data);
            }
            
            console.log(addProps)
            const jsonText = addProps.replace(/(\w+)\s*:\s*([\w]+)/g, '"$1": "$2"');
            const propObj = JSON.parse(jsonText);
            console.log(propObj)
            return JSON.stringify({
                ...data,
                ...propObj
            })

        },
        get postStart() {
            console.log(this.startDate)
            if (this.startDate === '') return ''
            return format(this.startDate, 'yyyy-MM-dd')
        },
        get postEnd() {
            console.log(this.endDate)
            if (this.endDate === '') return ''
            return format(this.endDate, 'yyyy-MM-dd')
        },
        get postPrograms() {
            return JSON.stringify(this.additionalServices)
        },
        get postRooms() {
            return JSON.stringify(this.rooms)
        },
        getPackagePrice(index: number, adultIndex: number) {
            return JSON.stringify({
                "ChangesModel.Posted": "true",
                "ChangesModel.Start": this.postStart,
                "ChangesModel.End": this.postEnd,
                "ChangesModel.Programs": "{ '" + this.rooms[index].Services[adultIndex] + "' : 1 }",
                "ChangesModel.Rooms": "{}"
            })
        }
    }

    return data;
}
